import { object, number, array } from '@gogame/schemas';

import {
  FILTER_STATUSES,
  FILTER_OWNERS,
  FILTER_CREATED_BY,
  FILTER_COUNTRIES,
  STATUS_ACTIVE,
} from 'scenes/PartnerCompanies/constants';

export const EMPTY_FILTERS = {
  [FILTER_STATUSES]: [STATUS_ACTIVE],
};

export const filtersSchema = object({
  [FILTER_STATUSES]: array(number()),
  [FILTER_OWNERS]: array(number()),
  [FILTER_CREATED_BY]: array(number()),
  [FILTER_COUNTRIES]: array(number()),
}).default(EMPTY_FILTERS);
